module.exports = __webpack_public_path__ + "img/updateImg2.ee1ce039.png";